import { useNavigate, useParams } from "react-router-dom";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import GeneralBlockParentForm from "../../../components/GeneralBlock/GeneralBlockParentForm";
import Header from "../../../components/Header/Header";
import SideNavbar from "../../../components/Navbar/SideNavbar";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getGeneralBlock, setGeneralBlock } from "../../../../core/actionCreators/blocksActionCreator";

const GeneralBlock = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [pageMode, setPageMode] = useState("");
    const { generalBlock, isLoading } = useSelector((s: any) => s.blocksStore);

    const backArrowClickHadler = () => {
        navigate("/blocks/general")
    }

    useEffect(() => {
        const currentPath = window.location.pathname;
        if (currentPath === "/blocks/general/create") {
            setPageMode("CREATE");
        } else {
            if (params.id) {
                setPageMode("EDIT");
                dispatch(getGeneralBlock(params.id, null));
            }
        }
        return () => {
            dispatch(setGeneralBlock({}));
        };
    }, [params, window]);

    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <div className="Subheader bg-white p-[15px] shadow-[0_2px_6px_rgba(0,0,0,.1)]">
                            <div className="flex items-center w-full">
                                <ArrowLeftSLineIcon onClick={backArrowClickHadler} size={24} className="mr-4" />
                                <p className="text-xl font-bold text-[#43425D] flex items-center">{pageMode === "EDIT" ? "Update" : "Create"} General Block</p>
                            </div>
                        </div>
                        <GeneralBlockParentForm pageMode={pageMode}
                            blockData={generalBlock} loaderFlag={isLoading} />
                    </div>
                </div>
            </div>
        </>
    )
}
export default GeneralBlock;